import { EpicDeps } from '@wearejh/m2-pwa-engine/lib/types';
import { DocumentNode } from 'graphql';

export type RequiredQueries = 'getCart';
export type DepsWithQueries = EpicDeps & { queries?: { getCart?: DocumentNode } };

export function getQuery(name: RequiredQueries, deps: DepsWithQueries): DocumentNode {
    const queries = deps.queries || {};
    const match = queries[name];
    if (!match) {
        throw new Error(`Missing query for ${name}`);
    }
    return match;
}
